import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const DEFAULT_BREAKPOINT = 1024

export function useIsMobile(breakpoint = DEFAULT_BREAKPOINT) {
  const isMobile = ref(false)
  let resizeListener

  const evaluate = () => {
    if (typeof window === 'undefined')
      return

    isMobile.value = window.innerWidth < breakpoint
  }

  onMounted(() => {
    evaluate()

    resizeListener = () => evaluate()
    window.addEventListener('resize', resizeListener, { passive: true })
  })

  onBeforeUnmount(() => {
    if (resizeListener)
      window.removeEventListener('resize', resizeListener)
  })

  return {
    isMobile: computed(() => isMobile.value),
    isDesktop: computed(() => !isMobile.value),
    refresh: evaluate,
  }
}
